<div class="voltar">
  <div class="subdiv" (click)="voltar()">
    <img src="assets/icons/arrow-back.svg" />
    <span>Voltar</span>
  </div>
</div>
